import { Button } from '@material-ui/core'
import axios from 'axios'
import React from 'react'
import { useRecoilState } from 'recoil'
import { chequeSettingsState } from '../recoil/atoms'

const ConfirmBankDelete = props => {
    const [chequeSettings, setChequeSettings] = useRecoilState(chequeSettingsState)
    const deleteHandler = () => {
        axios({
            url: 'accounts/cheque_setting/',
            method: "delete",
            data: {
                id: props.id
            }
        }).then(() => {
            setChequeSettings(chequeSettings.filter(chequeSetting => chequeSetting.id !== props.id))
            props.setPopup(false)
        })
    }

    return (
        <>
            <Button
                type="submit"
                variant="contained"
                color="secondary"
                style={{ margin: 10 }}
                onClick={deleteHandler}
            >
                بله
                </Button>
            <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ margin: 10 }}
                onClick={() => props.setPopup(false)}
            >
                خیر
            </Button>
        </>
    )
}

export default ConfirmBankDelete
